import { render, staticRenderFns } from "./DialogPaymentResult.vue?vue&type=template&id=20ab95cf&scoped=true&"
import script from "./DialogPaymentResult.vue?vue&type=script&lang=js&"
export * from "./DialogPaymentResult.vue?vue&type=script&lang=js&"
import style0 from "./DialogPaymentResult.vue?vue&type=style&index=0&id=20ab95cf&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20ab95cf",
  null
  
)

export default component.exports